<div class="row">
    <div class="col-sm-6">
        <h2>{{ buttonTitle }}</h2>
    </div>
    <div class="col-sm-6">


        <button type="submit" style="float: right" class="btn btn-primary px-4" (click)="onBack()">
            Back
        </button>
        <button type="submit" (click)="onSubmit()" style="float: right; margin-right: 10px"
            class="btn btn-primary px-4">
            Save
        </button>
        <button *ngIf="id" style="float: right;margin-right: 10px" class="btn btn-primary px-4"
            (click)="forceLogout('forceLogout')">Force Logout</button>
        <button *ngIf="id" style="float: right;margin-right: 10px" class="btn btn-danger px-4"
            (click)="forceLogout('Block')">{{blockBtn}}</button>
    </div>
</div>

<div class="col-12" style="margin-top: 20px">
    <nb-card>
        <nb-card-body style="position: relative">
            <form [formGroup]="userForm">
                <div class="row">
                    <div class="col-sm-6">
                        <label class="form-label">Name</label>
                        <input class="form-control" placeholder="Enter Name" formControlName="name" nbInput />
                    </div>

                    <div class="col-sm-6">
                        <label class="form-label">Email</label>
                        <input formControlName="email" class="form-control inputClassText" type="email"
                            placeholder="Enter Email" nbInput>
                        <div class="error-text"
                            *ngIf="userForm.get('email')?.hasError('required') && (userForm.get('email')?.touched)">
                            Enter your email
                        </div>
                        <div class="error-text"
                            *ngIf="userForm.get('email')?.hasError('email') && userForm.get('email')?.touched">
                            Invalid email format
                        </div>
                    </div>
                </div>

                <div class="row" style="margin-top: 20px">
                    <div class="col-sm-6">
                        <label class="form-label">Country Code</label>
                        <input class="form-control" placeholder="Enter Country" formControlName="country" nbInput />
                    </div>
                    <div class="col-sm-6">
                        <label class="form-label">Phone</label>
                        <!-- <input class="form-control" placeholder="Enter Phone" formControlName="phone" nbInput /> -->
                        <input class="form-control" pattern="[0-9]*" maxlength="" placeholder="Enter Phone"
                            formControlName="phone" (input)="onPhoneInput($event)" nbInput>
                    </div>
                </div>

                <div class="row" style="margin-top: 20px">
                    <div class="col-sm-6">
                        <label class="form-label">CPR Number</label>
                        <input class="form-control" placeholder="Enter CPR Number" formControlName="cprNumber" nbInput />
                    </div>
                </div>

                <div class="row" style="margin-top: 20px" *ngIf="id">
                    <div class="col-sm-12">
                        <label class="form-label">Admin Comments</label>
                        <textarea class="form-control" formControlName="adminComments"
                            placeholder="Internal admin notes (not visible to users)"
                            rows="5" nbInput></textarea>
                    </div>
                </div>

                <div class="row" style="margin-top: 20px" *ngIf="showField">
                    <div class="col-sm-6">
                        <label class="form-label">Date Of Birth</label>
                        <input nbInput placeholder=" Enter Date Of Birth" class="form-control" [nbDatepicker]="picker"
                            [value]="userForm.get('dateofbirth').value | date :'dd/MM/yyyy'">
                        <nb-datepicker #picker format="DD/MM/yyyy" (dateChange)="calculateAge($event)"
                            [max]="max"></nb-datepicker>
                    </div>
                    <div class="col-sm-6">
                        <label class="form-label">Age</label>
                        <input class="form-control" readonly placeholder="Age" formControlName="age" nbInput />
                    </div>
                </div>
                <div class="row" style="margin-top: 20px" *ngIf="showField">
                    <div class="col-sm-6">
                        <label class="form-label">Suspecious</label>
                        <ng-select formControlName="suspicious" [clearable]="false">
                            <ng-option *ngFor="let data of isSuspecious" [value]="data.value">{{
                                data.name
                                }}</ng-option>
                        </ng-select>
                    </div>
                    <div class="col-sm-6" style="margin-top: 20px">
                        <label class="form-label">Skip Age Verification</label>
                        <ng-select formControlName="skipAgeVerification" [clearable]="false">
                            <ng-option *ngFor="let data of isSkipAge" [value]="data.value">{{ data.name }}</ng-option>
                        </ng-select>
                    </div>
                    <!-- <div class="col-sm-6">
                        <label class="form-label">Block User</label>
                        <ng-select formControlName="isblocked" [clearable]="false">
                            <ng-option *ngFor="let data of isBlocked" [value]="data.value">{{
                                data.name
                                }}</ng-option>
                        </ng-select>
                    </div> -->
                </div>
                <div class="row" style="margin-top: 20px">

                    <div style="float: right" class="col-sm-6" *ngIf="isShowPaswordField">
                        <label class="form-label">Password </label>
                        <input [type]="showPassword ?   'password':'text'" class="form-control"
                            placeholder="Enter Password" formControlName="password" nbInput />

                        <button class="toggle_password" type="button" *ngIf="userForm.get('password').value !== ''"
                            (click)="togglePasswordVisibility()">

                            <i class="fa" [class.fa-eye]="!showPassword" [class.fa-eye-slash]="showPassword"
                                aria-hidden="true"></i>

                        </button>

                    </div>
                </div>

            </form>
            <div *ngIf="!isShowPaswordField" class="row">
                <div class="col-sm-12">
                    <button style="margin-right: 10px; float: right;" type="submit" class="btn btn-primary px-4"
                        (click)="openChangePassword()">
                        Change Password</button>
                    <button *ngIf="id" style="float: right; margin-right: 10px;" class="btn btn-info px-4"
                        (click)="viewUserCards()">
                        <i class="fa fa-id-card-o"></i> Manage Cards</button>
                </div>
            </div>
        </nb-card-body>
    </nb-card>
</div>